import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button
} from "@mui/material";

import img6 from "../../pictures/img6.jpg";
import CareerForm from "./CareerForm";
import { Link as RouterLink } from "react-router-dom";

function Careers() {

  const jobs = [
    {
      title: "Civil Engineer",
      description:
        "Looking for experienced civil engineers to manage and supervise construction projects."
    },
    {
      title: "Site Supervisor",
      description:
        "Responsible for site monitoring, team coordination and project execution."
    },
    {
      title: "Architect",
      description:
        "Design modern residential and commercial buildings using advanced design tools."
    }
  ];

  return (
    <>
    <Box>

      {/* HERO SECTION */}

      <Box
        sx={{
          height: { xs: "40vh", md: "55vh" },
          backgroundImage: `url(${img6})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center"
        }}
      >
        <Box sx={{ background: "rgba(0,0,0,0.5)", p: 3, borderRadius: 2 }}>
          <Typography variant="h3" fontWeight="bold">
            Careers
          </Typography>

          <Typography sx={{ mt: 1 }}>
            Build your future with Velvizhi Construction
          </Typography>
        </Box>
      </Box>

      {/* CAREERS CONTENT */}

      <Container sx={{ py: 8 }}>

        <Typography
          variant="h4"
          textAlign="center"
          fontWeight="bold"
          gutterBottom
        >
          Join Our Team
        </Typography>

        <Typography textAlign="center" sx={{ mb: 6 }}>
          We are always looking for talented engineers, architects and
          professionals who are passionate about construction and innovation.
        </Typography>

        <Grid container spacing={4}>

          {jobs.map((job, index) => (

            <Grid item xs={12} md={4} key={index}>

              <Card sx={{ height: "100%", boxShadow: 3 }}>

                <CardContent>

                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {job.title}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 3 }}>
                    {job.description}
                  </Typography>

                  <Button
                  component={RouterLink}
                  to="/contact-us"
                    variant="contained"
                    size="small"
                  >
                    Apply Now
                  </Button>

                </CardContent>

              </Card>

            </Grid>

          ))}

        </Grid>

      </Container>

    </Box>
    <CareerForm/>
    </>
  );
}

export default Careers;